import React from "react";

//import'./style.css';

const CaseSvg = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 512 418.89"
      >
        <path
          d="M29.06 67.65H160.3V20.57C160.3 9.24 169.54 0 180.87 0h150.26c11.33 0 20.57 9.24 20.57 20.57v47.08h131.24c16 0 29.06 13.06 29.06 29.07v293.1c0 8.01-3.27 15.28-8.53 20.54s-12.53 8.53-20.53 8.53H29.06c-8 0-15.27-3.27-20.53-8.53C3.27 405.1 0 397.83 0 389.82V96.72c0-16.01 13.06-29.07 29.06-29.07zm297.33-44.89H185.61c-1.38 0-2.55 1.16-2.55 2.55v41.96h145.88V25.31c0-1.39-1.17-2.55-2.55-2.55zM22.76 385.09c0 6.05 4.98 11.04 11.04 11.04h444.4c6.06 0 11.04-4.99 11.04-11.04V101.45c0-6.05-4.98-11.04-11.04-11.04H33.8c-6.06 0-11.04 4.99-11.04 11.04v283.64z"
        />
        <path
          d="M236.92 155.61h38.15c7.13 0 12.96 5.83 12.96 12.96v42.66h42.67c7.12 0 12.95 5.83 12.95 12.96v38.15c0 7.13-5.83 12.96-12.95 12.96h-42.67v42.66c0 7.13-5.83 12.96-12.96 12.96h-38.15c-7.13 0-12.96-5.83-12.96-12.96V275.3H181.3c-7.13 0-12.96-5.83-12.96-12.96v-38.15c0-7.13 5.83-12.96 12.96-12.96h42.66v-42.66c0-7.13 5.83-12.96 12.96-12.96z"
        />
      </svg>
    </React.Fragment>
  );
};

export default CaseSvg;
